import React from 'react';
import '../../../styles/Home.css';
import CommonMarketLaw from './Rankings/CommonMarketLaw'
import ComparativeLabourLaw from './Rankings/ComparativeLabourLaw'
import JournalOfWorldTrade from './Rankings/JournalOfWorldTrade'
import EconomicIntegration from './Rankings/EconomicIntegration'

const RankingTag = (props) => {
   const {data} = props;
   const widthValue = data.percentile + "%";
   const rankingAvailable = data.isAvailable;
   const url = data.url;

   if (rankingAvailable) {
    return(
        <div className="TopicBorder BGGrey" style={{ marginTop: "4%", overflow: "hidden", boxSizing: "border-box" }}>
        <a
          href={`${url}`}
          style={{ textDecoration: "none", color: "#505050" }}
        >
          <div
            style={{
              height: 100,
              width: "100%",
              boxSizing: "border-box",
              fontFamily: "Arial, Verdana, helvetica, sans-serif",
              backgroundColor: "#ffffff",
              display: "block",
            }}
          >
            <div style={{ padding: "0px 16px" }}>
              <div style={{ paddingTop: 3, lineHeight: 1 }}>
                <div style={{ float: "left", fontSize: 28 }}>
                  <span
                    id="citescoreVal"
                    style={{
                      letterSpacing: "-2px",
                      display: "inline-block",
                      paddingTop: 7,
                      lineHeight: ".75",
                    }}
                  >
                    {data.score}
                  </span>
                </div>
                <div
                  style={{
                    float: "right",
                    fontSize: 14,
                    paddingTop: 3,
                    textAlign: "right",
                  }}
                >
                  <span id="citescoreYearVal" style={{ display: "block" }}>
                    {data.year}
                  </span>
                  CiteScore
                </div>
              </div>
              <div style={{ clear: "both" }} />
              <div style={{ paddingTop: 3 }}>
                <div style={{ height: 4, backgroundColor: "#DCDCDC" }}>
                  <div
                    style={{ height: 4, backgroundColor: "#007398",
                    width: widthValue }}
                    id="percentActBar"
                  >
                    &nbsp;
                  </div>
                </div>
                <div style={{ fontSize: 11 }}>
                  <span id="citescorePerVal">{data.percentile} percentile</span>
                </div>
              </div>
              <div style={{ fontSize: 12, textAlign: "right" }}>
                Powered by &nbsp;
                <span>
                  <img
                    alt="Scopus"
                    style={{ width: 50, height: 15 }}
                    src="/../../images/scopusLogoOrange.svg"
                  />
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
       )
   }
else
{
    return(
        <div></div>
    )
}
   
};

export default RankingTag;


// WEBPACK FOOTER //
// ./src/components/Journals/Subitems/RankingTag.jsx